import { hide_dropdown_sidebar } from "./subSidebarListItemWithSubMenu";

export async function setHamburgerMenuState(queryClient)
{
    
    const state =  await queryClient.getQueryData('hamburgerMenuStatus') || 'Close';

    if(state=="Close")
    {
        openHamburgerMenuElement();
        hide_dropdown_sidebar();
        queryClient != null ? await queryClient.setQueryData('hamburgerMenuStatus', ()=> {return "Open"}) : '';
    }
    else
    {
        closeHamburgerMenuElement();
        queryClient != null ? await queryClient.setQueryData('hamburgerMenuStatus', ()=> {return "Close"}) : '';
    }
}

export function getHamburgerMenuElement()
{
    return document.querySelector('.MobileMenuContainer .HamburgerMenu__List');
}

export function openHamburgerMenuElement()
{  
    var element = getHamburgerMenuElement(); 
    element.classList.remove('Close');
    element.classList.add('Open');
}

export function closeHamburgerMenuElement()
{
    var element = getHamburgerMenuElement(); 
    element.classList.remove('Open');
    element.classList.add('Close');
}